import React from "react";
import PropTypes from "prop-types";
import MSBCommunityChat from "./CommunityChat";
import EnableCommunityChat from "./EnableCommunityChat";
import { useRillContext } from "../../../rill/RillReact/share/base";

const CommunityChatWrapper = ({ api }) => {
  const context = useRillContext();

  const { locals } = context;
  const { activeUserToRequest } = locals;
  const { pushAccountInfo, pressAccountInfo, pullAccountInfo } = activeUserToRequest;
  const userCanAccessToCommunityChat =
    pushAccountInfo?.inAppCommunityEnabled ||
    pressAccountInfo?.inAppCommunityEnabled ||
    pullAccountInfo?.inAppCommunityEnabled;

  const isValidObject = (obj) =>
    obj && typeof obj === "object" && !Array.isArray(obj);

  const isPush = isValidObject(pushAccountInfo);
  const isPress = isValidObject(pressAccountInfo);
  const isPull = isValidObject(pullAccountInfo);

  return userCanAccessToCommunityChat ? (
    <MSBCommunityChat locals={locals} api={api} />
  ) : (
    <EnableCommunityChat isPush={isPush} isPress={isPress} isPull={isPull} />
  );
};

CommunityChatWrapper.propTypes = {
  api: PropTypes.any,
};

export default CommunityChatWrapper;
